// import BannerImageContent from "./BannerImageContent";
import wellnessLogo from "../assets/images/buttons/CHww.webp";

const WelcomeContent = () => {
  return (
    <>
      {/* booking static section */}
   
        <div className="w-full rounded-none">
          {/* <div className="absolute h-full w-full -z-10">
            <div className="absolute h-full w-full bg-gradient-to-l from-white/100 to-transparent" />
            <img
              src={bg3}
              alt="image 2"
              className="w-full h-full object-cover rounded-none "
            />
          </div> */}

          <div className="p-2 ">
            <div className="mb-2">
              <p className="w-full Blinker-Bold lg:text-[2.7rem] md:text-5xl text-[2rem] px-3 text-gray-700 antialiased block font-light  text-center leading-7">
                Welcome to Ceylon Hospitals
              </p>
            </div>
            <div className="flex flex-col justify-center items-center px-4 mt-5">
              <p className="Blinker-Light text-gray-700  text-justify lg:px-16  mb-4">
                At Ceylon Hospital, we are dedicated to providing compassionate,
                high-quality healthcare with a commitment to excellence. Our
                team of experienced medical professionals, state-of-the-art
                facilities, and patient-centered approach ensure that you
                receive the best possible care. Whether you are here for a
                routine check-up, specialized treatment, or emergency care, we
                prioritize your health and well-being above all else. We strive
                to create a healing environment where you feel safe, supported,
                and confident in your care.Thank you for choosing Ceylon
                Hospital. Your health is our priority.
              </p>

              <p className="Blinker-Regular leading-snug  py-1 text-gray-700 text-lg text-center lg:px-10 px-2 mb-4">
                By clicking the button below, you will be redirected to our
                Ceylon Wellness website.
              </p>
            </div>

            {/* <div className="mb-10 flex flex-row gap-2 px-4 justify-center items-center">
              <a
                href="https://wellness.ceylonhospital.com/"
                target="_blank"
                rel="noopener noreferrer"
                className=" text-sm text-gray-500 hover:shadow-md hover:opacity-90  flex flex-row  justify-center rounded-full"
              >
                <img
                  src={wellnessLogo}
                  alt="image"
                  loading="lazy"
                  className="h-28 w-80 rounded-full"
                />
              </a>
            </div> */}
            <div className="mb-10 flex flex-row gap-2 px-4 justify-center items-center">
              <a
                href="https://wellness.ceylonhospital.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:shadow-md hover:opacity-90 flex flex-row justify-center rounded-full transition-all duration-200 p-2"
              >
                <img
                  src={wellnessLogo}
                  alt="Ceylon Hospital Wellness Logo"
                  loading="lazy"
                  width={320}
                  height={112}
                  className="h-28 w-80 rounded-full object-cover max-w-full"
                  style={{
                    aspectRatio: "320/112", // Maintain original aspect ratio
                  }}
                />
              </a>
            </div>

            {/* <BannerImageContent /> */}
          </div>

      </div>
    </>
  );
};

export default WelcomeContent;
